import { createContext, useContext, useState, useCallback, useRef } from 'react';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({ message: '', visible: false, isLight: false, type: 'default' });
    const [animation, setAnimation] = useState('d-none');
    const toastQueue = useRef([]);
    const processQueue = useCallback(() => {
        if (toastQueue.current.length === 0) return;
        const { message, delay, isLight, type } = toastQueue.current.shift();
        setToast({ message, visible: true, isLight, type });
        setAnimation('pShowToast');
        setTimeout(() => {
            setAnimation('pHideToast');
            setTimeout(() => {
                setToast(prev => ({ ...prev, visible: false }));
                processQueue();
            }, 750);
        }, delay);
    }, []);
    const showToast = useCallback((message, delay = 2000, isLight = false, type = 'default') => {
        if (toast.visible) {
            toastQueue.current.push({ message, delay, isLight, type });
        } else {
            toastQueue.current.push({ message, delay, isLight, type });
            processQueue();
        }
    }, [toast.visible, processQueue]);

    return (
        <>
            <style>{`
                .pToast {
                    transform: translateY(100px);
                }
                .pShowToast {
                    animation: pShowToast 0.75s ease-in-out forwards;
                }
                .pHideToast {
                    animation: pHideToast 0.75s ease-in-out forwards;
                }
                @keyframes pShowToast {
                    0% { transform: translateY(100px); }
                    15% { transform: translateY(-50px); }
                    30% { transform: translateY(0px); }
                    45% { transform: translateY(-25px); }
                    60% { transform: translateY(0px); }
                    75% { transform: translateY(-10px); }
                    90% { transform: translateY(0px); }
                    100% { transform: translateY(0px); }
                }
                @keyframes pHideToast {
                    0% { transform: translateY(0px); }
                    15% { transform: translateY(-50px); opacity: 0.5; }
                    30% { transform: translateY(100px); }
                    45% { transform: translateY(75px); }
                    60% { transform: translateY(100px); opacity: 0; }
                    75% { transform: translateY(90px); }
                    90% { transform: translateY(100px); }
                    100% { transform: translateY(100px); opacity: 0; }
                }
            `}</style>

            <ToastContext.Provider value={{ showToast }}>
                {children}
                <div className="dfCec bg-body" style={{
                    position: 'fixed',
                    width: '100dvw',
                    backgroundColor: 'white',
                    height: '100dvh`',
                    zIndex: 1000,
                }}>
                    <span
                        className={`dfcc gap-3 transition  user-select-none pToast ${animation} `}
                        style={{
                            position: 'fixed',
                            letterSpacing: '1px',
                            bottom: '25px',
                        }}
                        >
                        <span className={`px-3 dfcc text-center`} style={{
                            minWidth: '200px',
                            height: '50px',
                            backgroundColor: 'white',
                            border: '1px solid #e8eef5',
                            borderRadius: '12px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            color: '#1a1a2e',
                            fontWeight: '500',
                            fontSize: '14px'
                        }}>                            
                        {toast.message || "This is a toast message!"}
                        </span>
                        {(toast.type === 'success' || toast.type === 'danger') &&
                            <div className="dfcc" style={{
                                borderRadius: "12px",
                                width: '50px',
                                height: '50px',
                                backgroundColor: 'white',
                                border: '1px solid #e8eef5',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            }}>
                                <div className={`dfcc`} style={{
                                    borderRadius: '50%',
                                    width: '24px',
                                    height: '24px',
                                    backgroundColor: toast.type === 'success' ? '#4CAF50' : '#f44336'
                                }}>
                                    <i className={`fa ${toast.type === 'success' ? 'fa-check' : 'fa-times'} text-white w-100 text-center`} style={{ fontSize: '12px' }}></i>
                                </div>
                            </div>
                        }
                    </span>
                </div>
            </ToastContext.Provider>
        </>
    );
};

export const useToast = () => useContext(ToastContext);

